/**
 * Indian-numbering currency formatting helpers + defensive copy utilities.
 *
 * formatINR(140000) -> "₹1,40,000"
 * formatINR(95000)  -> "₹95,000"
 */
const _INR = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

export function formatINR(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }
  return _INR.format(Number(value));
}

/**
 * Defensive: scrub any individual photographer / crew names that may have
 * leaked into seed data. Buyer must only ever see "ShutterKART Support".
 */
export function scrubCrewNames(text) {
  if (typeof text !== "string") return text;
  return text.replace(
    /\b(photographer|cinematographer)\s+(Mr\.?|Ms\.?|Mrs\.?)?\s*[A-Z][a-z]+(\s+[A-Z][a-z]+)?\b/gi,
    "ShutterKART crew",
  );
}

/**
 * Pick a sensible cover for any catalog entity (service / package).
 * Always falls back to a portfolio image if available.
 */
export function pickCover(entity, portfolioFallback) {
  return (
    entity?.cover_image ||
    entity?.hero_image_url ||
    entity?.image_url ||
    entity?.url ||
    portfolioFallback?.url ||
    portfolioFallback?.thumbnail_url ||
    null
  );
}
